import useTranslations from "@/shared/lang/useTranslations";
import { cn } from "@/shared/lib/utils";

import { TIER_INFO, type IdentityTier } from "../constants/identityTiers.constants";

type TierBadgeProps = {
  tier: IdentityTier;
  className?: string;
};

export const TierBadge = ({ tier, className }: TierBadgeProps) => {
  const { t } = useTranslations("cards");
  const info = TIER_INFO[tier];

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-medium",
        className,
      )}
      style={{
        background: `${info.color}22`,
        color: info.color,
      }}
    >
      <span
        className="inline-block h-1.5 w-1.5 rounded-full"
        style={{ background: info.color }}
        aria-hidden="true"
      />
      {t(info.labelKey as never)}
    </span>
  );
};
